//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums, StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

/** Asks before a save drops a split periodisation whose rows no longer add up to the net. */
function useSplitPeriodisationRemovalConfirmation() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  // Avbryt, X, Esc and click-outside all close through onClose, so each of them answers no.
  return () =>
    new Promise<boolean>((resolve) => {
      dispatch(
        displayDialog({
          isOpen: false,
          title: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.SplitPeriodisationRemovalTitle
          ),
          titleIcon: IconDefinitionConstants.WExclamationTriangle,
          actions: [
            {
              text: LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.IncomingInvoice.SplitPeriodisationRemovalConfirm
              ),
              onClick: async () => resolve(true),
              type: StyleEnums.DisplayType.Info,
            },
          ],
          dialogType: DialogEnums.DialogType.Message,
          children: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.SplitPeriodisationRemovalMessage
          ),
          onClose: () => resolve(false),
        })
      );
    });
}

export default useSplitPeriodisationRemovalConfirmation;
